// Auto-generated translation for hr.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:38:31.463349+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Za vlasnike konja",
    title: "Sve za tvoga konja. U jednoj aplikaciji.",
    subtitle: "Upravljaj zdravljem, treningom, planiranjem i stručnjacima iz jednog preglednog dosjea.",
    primaryCTA: {
      label: "Počni besplatno",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pogledaj Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Profil konja — težina, cijepljenje, EquiCoach, prehrana i trening na jednom zaslonu",
      caption: "Tvoj konj, potpuno pregledan.",
    },
    problem: "Vjerojatno trenutno vodiš evidenciju termina, fotografija, treninga, prehrane i zdravlja na raznim mjestima — u WhatsApp grupama, kutijama s dokumentima i zasebnim aplikacijama. Zbog toga gubiš pregled.",
    solution: "EquiSight pretvara tvoga konja u jedan potpun digitalni dosje koji uvijek imaš uz sebe.",
    benefits: [
      "Jedan potpun profil po konju",
      "Zdravlje, potkivač, zubar i fizioterapeut na jednom mjestu",
      "Kalendar s pametnim podsjetnicima",
      "Fotografije, bilješke i povijest bez ograničenja",
      "Sigurnosna pohrana svih podataka uz Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 konj · uvijek besplatno",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Više konja + sigurnosna pohrana",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Spreman za početak?",
      title: "Počni danas sa svojim prvim konjem.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Više konja. Bolji pregled. Veća sigurnost.",
    subtitle: "Nadogradite na Premium i upravljajte svim svojim konjima bez ograničenja — s punom EquiCoach inteligencijom.",
    primaryCTA: {
      label: "Počnite besplatno 14 dana",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Sve cijene",
      href: "/#pricing",
    },
    audience: "Za vlasnike, sportske jahače i uzgajivače s više konja.",
    features: [
      "Dodavanje neograničenog broja konja",
      "Potpuna povijest svakog konja",
      "Sigurnosna pohrana podataka",
      "Napredni EquiCoach uvidi",
      "Pametne obavijesti i planiranje",
      "Zdravlje i trening potpuno povezani",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Manje od €0,17 po danu",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Spremni?",
      title: "Nadogradite na Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Za jahače u jahačkom klubu",
    title: "Napreduj, čak i bez vlastitog konja.",
    subtitle: "Prati svoje lekcije, treninge i razvoj unutar EquiSighta — za manje od šalice kave mjesečno za tatu ili mamu. Ili ukusnog sladoleda s vrhnjem.",
    primaryCTA: {
      label: "Započni s Premiumom",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kako to funkcionira?",
      href: "#features",
    },
    problem: "Kao jahač u jahačkom klubu često nemaš vlastitog konja, ali ipak želiš napredovati i imati pregled nad svojim lekcijama, ciljevima i konjima na kojima jahaš.",
    solution: "Funkcionalnost jahačkog kluba standardno je uključena u Premium — prati vlastiti razvoj i pregledaj povezane konje jahačkog kluba samo za čitanje.",
    features: [
      "Praćenje treninga",
      "Postavljanje ciljeva",
      "Praćenje napretka",
      "Pregled konja jahačkog kluba s imenom i fotografijom",
      "Bez pristupa privatnim zdravstvenim podacima",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mjesečno · funkcionalnost jahačkog kluba uključena",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Postani član",
      title: "Započni kao jahač u jahačkom klubu.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Za jahačke klubove i staje",
    title: "Učinite svoj jahački klub digitalno dostupnim svakom jahaču.",
    subtitle: "Dajte jahačima uvid u konje, lekcije i napredak — bez dijeljenja osjetljivih podataka o staji.",
    primaryCTA: {
      label: "Zatražite pristup",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pogledajte module",
      href: "#features",
    },
    audience: "EquiSight pomaže jahačkim klubovima i stajama da dulje zadrže angažiranost jahača i istaknu se u digitalnom prostoru.",
    features: [
      "Učinite konje jahačkog kluba vidljivima jahačima",
      "Ime i fotografija za svakog konja",
      "Povezivanje jahača s konjima",
      "Pristup samo za čitanje za osjetljive podatke",
      "Centralna povijest lekcija i treninga",
      "Upravljanje korisnicima s ulogama",
    ],
    benefits: [
      "Veća povezanost s jahačima",
      "Profesionalniji izgled",
      "Dodatna digitalna usluga za članove",
      "Novi izvor prihoda putem korištenja aplikacije",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mjesečno · funkcionalnost jahačkog kluba uključena za jahače",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Spremni?",
      title: "Aktivirajte modul jahačkog kluba.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Modul uzgoja",
    title: "Kontrola nad ciklusom, gravidnošću i razvojem ždrebeta.",
    subtitle: "Potpuni modul uzgoja za vlasnike kobila i uzgajivače — od parenja do ždrebeta, na jednoj vremenskoj liniji.",
    primaryCTA: {
      label: "Aktiviraj modul uzgoja",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pogledaj funkcije",
      href: "#features",
    },
    audience: "Za uzgajivače, vlasnike kobila i staje koje upravljaju s više kobila.",
    features: [
      "Praćenje ciklusa",
      "Bilježenje tjeranja",
      "Unos podataka o inseminaciji",
      "Odbrojavanje do eho pregleda",
      "Planiranje kontrola gravidnosti",
      "Rodovnik i porijeklo",
      "Razvoj ždrebeta",
      "Pregled svih gravidnih kobila",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Mjesečno · Modul uzgoja uključen u Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Počni danas",
      title: "Započni s upravljanjem uzgojem.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Modul za potkivače",
    title: "Radite pametnije kao potkivač. Bilježite sve na profesionalan način.",
    subtitle: "Raspored, fotografije, bilješke i povijest tretmana u jednom modulu — manje nesporazuma, jači dosje.",
    primaryCTA: {
      label: "Započnite kao potkivač",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pogledajte Professional paket",
      href: "/professional",
    },
    audience: "Za potkivače koji žele poboljšati pregled, dokumentaciju i komunikaciju s klijentima.",
    features: [
      "Vlastiti raspored",
      "Termini po klijentu",
      "Pregled profila konja",
      "Dodavanje fotografija prije i poslije",
      "Bilježenje tretmana",
      "Zapisivanje savjeta i napomena",
      "ETA obavijest klijentu: \"Potkivač je na putu\"",
    ],
    benefits: [
      "Profesionalniji rad",
      "Manje nesporazuma",
      "Bolja izgradnja dosjea",
      "Jača pozicija pri odgovornosti",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Mjesečno · Modul za potkivače uključen u Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Spremni?",
      title: "Aktivirajte modul za potkivače.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Modul zubara",
    title: "Potpun zubni dosje za svakog konja.",
    subtitle: "Bilježite nalaze, tretmane i praćenje izravno u EquiSightu.",
    primaryCTA: {
      label: "Počnite kao konjski zubar",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pogledajte Professional paket",
      href: "/professional",
    },
    audience: "Konjski zubari, veterinari i prakse koje žele raditi strukturirano.",
    features: [
      "Evidentiranje pregleda zuba",
      "Nalazi po tretmanu",
      "Dodavanje fotografija",
      "Izvješće vlasniku",
      "Savjeti za praćenje",
      "Povijest po konju",
      "Zakazivanje novog termina",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Mjesečno · Modul zubara uključen u Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Spremni?",
      title: "Aktivirajte modul zubara.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Modul fizioterapije / osteopatije",
    title: "Profesionalno pratite tijelo, kretanje i oporavak.",
    subtitle: "Za fizioterapeute i osteopate koji žele strukturirano pratiti konje.",
    primaryCTA: {
      label: "Počnite kao fizioterapeut/osteopat",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pogledajte Professional paket",
      href: "/professional",
    },
    features: [
      "Unos podataka po konju",
      "Bilježenje tjelesnih nalaza",
      "Dodavanje fotografija i videozapisa",
      "Izrada izvještaja o tretmanu",
      "Dijeljenje vježbi i praćenja",
      "Praćenje tijeka oporavka",
      "Povijest po konju",
    ],
    benefits: [
      "Bolji uvid kroz vrijeme",
      "Profesionalno izvještavanje",
      "Jasna komunikacija s vlasnikom, trenerom i jahačem",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Mjesečno · Modul fizioterapije / osteopatije uključen u Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Spremni?",
      title: "Aktivirajte modul fizioterapije / osteopatije.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Trenerski modul",
    title: "Trenirajte jahače s podacima, ciljevima i napretkom.",
    subtitle: "Učinite trening mjerljivim i vođenje profesionalnijim — za jednog ili više jahača.",
    primaryCTA: {
      label: "Počnite kao trener",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pogledajte Pro paket",
      href: "/#pricing",
    },
    audience: "Za instruktore, trenere i coaches s više jahača ili konja.",
    features: [
      "Povezivanje jahača",
      "Praćenje konja",
      "Postavljanje ciljeva treninga",
      "Davanje povratnih informacija",
      "Analiza rezultata natjecanja",
      "Pregled napretka po kombinaciji",
      "Korištenje analiza protokola za fokus treninga",
    ],
    benefits: [
      "Bolje vođenje",
      "Više strukture",
      "Profesionalnija komunikacija",
      "Veća povezanost s klijentima",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Mjesečno · Trenerski modul uključen u Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Spremni?",
      title: "Aktivirajte Trenerski modul.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Analiza natjecanja",
    title: "Od protokola do poboljšanja rezultata.",
    subtitle: "Učitaj protokol natjecanja i otkrij gdje gubiš bodove — ne samo pregledaj svoj rezultat, već razumi kako postati bolji.",
    primaryCTA: {
      label: "Analiziraj svoj prvi protokol",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pogledaj Premium",
      href: "/premium",
    },
    features: [
      "Učitavanje fotografije protokola",
      "Obrada prednje i stražnje strane",
      "Prepoznavanje klase, broja provjere i suca",
      "Analiza ocjena po elementima",
      "Sažimanje komentara",
      "Prikaz snaga i slabosti",
      "Trendovi po kombinaciji konj-jahač",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mjesečno · analiza natjecanja uključena od Premiuma nadalje",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Spreman?",
      title: "Počni s analizom natjecanja.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional paket",
    title: "Za profesionalce oko konja.",
    subtitle: "Kovač, veterinar-zubar, fizioterapeut, osteopat ili trener: surađujte u jednom digitalnom dosjeu konja.",
    primaryCTA: {
      label: "Započni kao profesionalac",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pogledaj pojedinačne module",
      href: "#features",
    },
    audience: "Professional paket kombinira sve stručne module u jednu pretplatu.",
    features: [
      "Modul za kovače",
      "Modul za veterinare-zubara",
      "Modul za fizioterapiju / osteopatiju",
      "Kalendar i upravljanje klijentima",
      "Profili konja i izvješća",
      "Povijest tretmana i izgradnja dosjea",
      "Komunikacija s vlasnikom",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Mjesečno · svi stručni moduli uključeni",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Spremni?",
      title: "Odaberite Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Hitni brojevi za konja",
    title: "Uvijek prava pomoć nadohvat ruke.",
    subtitle: "U hitnom slučaju svaka sekunda je važna. S EquiSightom imaš sve važne kontaktne podatke svog konja odmah pri ruci — jedan dodir i poziv je u tijeku.",
    primaryCTA: {
      label: "Pripremi svoje hitne kontakte",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Počni besplatno s EquiSightom",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Hitni kontakti — izravno zovi, šalji WhatsApp poruke ili navigiraj do veterinara, klinike i potkivača",
      caption: "Jedan dodir. Bez panike i traženja.",
      embeddedFrame: true,
    },
    problem: "Nešto nije u redu s tvojim konjem — kolika, ozljeda, panika. I onda počinje traženje. Koga zoveš? Imaš li pravi broj? Je li to broj za hitne slučajeve? Dragocjeno vrijeme odlazi.",
    solution: "S EquiSightom imaš sve odmah pri ruci. Bez traženja. Bez sumnje. Jedan dodir i uspostavljaš kontakt.",
    scenario: {
      title: "Zamislite — vaš konj pokazuje simptome kolike.",
      steps: [
        "Otvoriš EquiSight",
        "Klikneš na \"Veterinar\"",
        "Odmah zoveš",
      ],
      tagline: "Bez stresa. Bez traženja. Samo akcija.",
    },
    features: [
      "Svi hitni brojevi na jednom mjestu",
      "Poziv jednim dodirom iz aplikacije",
      "WhatsApp poruka jednim dodirom",
      "Izravna navigacija do adrese",
      "Vlastiti popis kontakata za svakog konja",
      "Veterinar, klinika, potkivač, zubar, fizioterapeut",
      "Adresa i upute za dolazak odmah dostupni",
      "Označi omiljene brojeve zvjezdicom",
      "Hitni brojevi (112, 144) uvijek na vrhu",
    ],
    benefits: [
      "Smirenost i kontrola u hitnoj situaciji",
      "Svi u štali imaju iste brojeve pri ruci",
      "Nema više zaboravljenih posjetnica",
      "Reagiraj nekoliko sekundi brže u hitnim slučajevima",
    ],
    audience: "Za vlasnike konja, njegatelje, trenere i staje — sve koji su odgovorni za konja.",
    showcase: {
      eyebrow: "Unaprijed postavljeno za tebe",
      title: "13 kategorija kontakata — spremno za popunjavanje.",
      description: "Od veterinara i hitne klinike do sedlara, instruktora i upravitelja pašnjaka. EquiSight poznaje tvoj svijet i unaprijed priprema odgovarajuća kontaktna polja. Dodirni, ispuni, gotovo.",
      bullets: [
        "Hitno i zdravlje — veterinar, hitna pomoć, klinika, linija za trovanje",
        "Svakodnevna njega — potkivač, zubar, fizioterapeut, instruktor",
        "Štala i pašnjak — vlasnik staje, upravitelj pašnjaka, pansion",
        "Hrana i materijali — dobavljači sijena, koncentrirane hrane, slame",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Zaslon za upravljanje hitnim kontaktima — svi predloženi kontakti po kategoriji",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Kontrolna lista hitnih brojeva za konja",
      items: [
        "Veterinar",
        "Hitna klinika (24/7)",
        "Veterinarska hitna služba · 144",
        "Potkivač",
        "Zamjenski kontakt",
        "Opći broj za hitne slučajeve · 112",
      ],
      cta: {
        label: "Otvori u EquiSightu i odmah ispuni",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Hitni brojevi",
          price: "Gratis",
          note: "Uvijek besplatno · za sve, u svakoj pretplati",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pobrinite se da budete pripremljeni",
      title: "Prije nego što bude potrebno.",
      href: "/#waitlist",
    },
    microcopy: [
      "Bez obveza",
      "Postavljeno za 2 minute",
      "Uvijek prilagodljivo",
    ],
  },
};

export default LANDINGS;
